<template>
    <div>
        <div style="display: flex;flex-direction: row">
            <div style="display: flex;flex-direction: row">
                <div>
                    <canvas id="msg"></canvas>
                </div>
                <div v-if="imgUrl">
                    <img :src="imgUrl" style="width: 150px" @click="handleGetCert">
                </div>
                <div v-else>
                    <div class="el-icon-refresh"  style="font-size: 50px;height: 150px;line-height: 150px;" @click="handleGetCert"></div>
                </div>
            </div>
            <div style="display: flex;flex-direction: column;padding-left: 50px">
                <div >
                    押金：{{$parentInfo.Dialogs_ReturnEquipment.deposit.payment|currency('￥')}}   日租金：{{$parentInfo.Dialogs_ReturnEquipment.deposit.dailyRent|currency('￥')}}   免租日：{{$parentInfo.Dialogs_ReturnEquipment.deposit.freeDay}} 天  <br>
                    交易日期：{{$parentInfo.Dialogs_ReturnEquipment.deposit.borrow_date}}   剩余押金：{{$parentInfo.Dialogs_ReturnEquipment.deposit.remainBalance|currency('￥')}}
                </div>
                <div>
                    <el-row :gutter="5">
                        <el-col :span="24">
                                <el-input v-model="$parentInfo.Dialogs_ReturnEquipment.filter.discount_rent"
                                          type="number"
                                          placeholder="租金优惠" style="width: 200px"></el-input>
                        </el-col>
                        <el-col :span="12">
                            <el-input v-model="$parentInfo.Dialogs_ReturnEquipment.filter.repair_balance"
                                      type="number"
                                      placeholder="维修赔偿款" style="width: 200px"></el-input>
                        </el-col>
                        <el-col :span="12">
                            <el-input v-model="$parentInfo.Dialogs_ReturnEquipment.filter.repair_content"
                                      placeholder="维修内容"  style="width: 200px"></el-input>
                        </el-col>
                        <el-col :span="24">
                            <el-select v-model="$parentInfo.Dialogs_ReturnEquipment.filter.balanceType" placeholder="押金处理" style="width: 200px">
                                <el-option
                                        v-for="item in balanceTypes"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="12">
                            <el-input v-model="$parentInfo.Dialogs_ReturnEquipment.filter.guardianName"
                                      placeholder="监护人"  style="width: 200px"></el-input>
                        </el-col>
                        <el-col :span="12">
                            <el-input v-model="$parentInfo.Dialogs_ReturnEquipment.filter.guardianId"
                                      placeholder="租赁人/租赁人监护人身份证号"  style="width: 200px"></el-input>
                        </el-col>
                        <el-col :span="24">
                            <el-input v-model="$parentInfo.Dialogs_ReturnEquipment.filter.guardianPhone"
                                      placeholder="联系方式"  style="width: 200px"></el-input>
                        </el-col>
                        <el-col :span="24">
                            <el-input v-model="$parentInfo.Dialogs_ReturnEquipment.filter.accountName"
                                      placeholder="开户人"  style="width: 200px"></el-input>
                        </el-col>
                        <el-col :span="24">
                            <el-input v-model="$parentInfo.Dialogs_ReturnEquipment.filter.bankAccount"
                                      placeholder="账号"  style="width: 200px"></el-input>
                        </el-col>
                        <el-col :span="24">
                            <el-input v-model="$parentInfo.Dialogs_ReturnEquipment.filter.bank"
                                      placeholder="开户行"  style="width: 200px"></el-input>
                        </el-col>

                    </el-row>
                </div>
            </div>
        </div>

        <div style="text-align: right">
            <el-button @click="handlePrint()">打印签收单</el-button>
            <el-button @click="handleDelivery()">确认交货</el-button>
        </div>
        <el-dialog
                title="归还确认书"
                :visible.sync="$parentInfo.Dialogs_ReturnEquipment.dialogVisible"
                width="950px"
                :before-close="handleClose"
                append-to-body
        >
            <Dialogs_ReturnConfirm v-if="$parentInfo.Dialogs_ReturnEquipment.dialogVisible" :invoice_id="$store.state.modal.data.invoiceId"></Dialogs_ReturnConfirm>
        </el-dialog>
    </div>
</template>

<script>
    import store from '@/store'
    import Dialogs_ReturnConfirm from './Dialogs_ReturnConfirm'
    import QRCode from 'qrcode'
    export default {
        name: "Dialogs_ReturnEquipment",
        data() {
            return {
                QRCodeMsg:'234',
                dialogVisible:false,
                filter:{
                    rent_discount:'',
                    service_balance:'',
                    service_dispose:'',
                    service_content:'',
                    rent_dispose:'',
                    account_holder:'',
                    account:'',
                    account_bank:'',
                },
                balanceTypes:[
                    {
                        id:1,
                        name:'用于支付'
                    },
                    {
                        id:2,
                        name:'退还'
                    }
                ],
                imgUrl:''
            };
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.QRCodeMsg='https://web.xuezhi.app/#/warehouse/upload/'+this.$store.state.modal.data.invoiceId+'/3'
            this.handleGetCert();
            this.handleGetDetail();
        },
        mounted(){
            var msg= document.getElementById('msg')
            // 将获取到的数据（val）画到msg（canvas）上
            QRCode.toCanvas(msg, this.QRCodeMsg, function (error) {
            })
        },
        components: {
            'Dialogs_ReturnConfirm':Dialogs_ReturnConfirm
        },
        destroyed() {
            this.$parentInfo.Dialogs_ReturnEquipment.filter={
                balanceType:'',
                bank:'',
                bankAccount:'',
                accountName:'',
                discountRent:'',
                repairMoney:'',
                repairContent:'',
                account_bank:'',
                guardianId:'',
                guardianName:'',
                guardianPhone:'',
                discount_rent:0,
                repair_balance:0,
                repair_content:'',
                totalRent:0,
                balance:0
            }
        },
        methods: {
            handleGetCert(){
                this.$axios.get(store.state.server + '/getCert?invoiceId='+this.$store.state.modal.data.invoiceId+'&type=3')
                    .then((response) => {
                        if (response.data.code == '0000') {
                            if(response.data.content.result.image){
                                this.imgUrl=response.data.content.result.image.url
                            }

                        }
                    }).catch((res) => {
                    this.$message({
                        type: 'error',
                        message: res.response.data.content
                    });
                    this.$Win.closeModal();
                })
            },
            handleGetDetail(){
                this.$axios.get(store.state.server + '/depositHandle?invoiceId='+this.$store.state.modal.data.invoiceId)
                    .then((response) => {
                        if (response.data.code == '0000') {
                            this.$parentInfo.Dialogs_ReturnEquipment.deposit=response.data.content
                            this.$parentInfo.Dialogs_ReturnEquipment.filter.remainBalance=this.$parentInfo.Dialogs_ReturnEquipment.deposit.remainBalance
                            this.$parentInfo.Dialogs_ReturnEquipment.filter.totalRent=this.$parentInfo.Dialogs_ReturnEquipment.deposit.rent
                            this.$parentInfo.Dialogs_ReturnEquipment.filter.balance=this.$parentInfo.Dialogs_ReturnEquipment.deposit.payment
                        }
                    }).catch((res) => {
                        this.$message({
                            type: 'error',
                            message: res.response.data.content
                        });
                })
            },
            handlePrint(){
                this.$parentInfo.Dialogs_ReturnEquipment.dialogVisible=true
            },
             handleDelivery(){

                 if(!this.$parentInfo.Dialogs_ReturnEquipment.filter.discountRent){
                    this.$parentInfo.Dialogs_ReturnEquipment.filter.discountRent=0
                 }

                 if(!this.$parentInfo.Dialogs_ReturnEquipment.filter.remainBalance){
                     this.$parentInfo.Dialogs_ReturnEquipment.filter.remainBalance=0
                 }

                 if(!this.$parentInfo.Dialogs_ReturnEquipment.filter.repairMoney){
                     this.$parentInfo.Dialogs_ReturnEquipment.filter.repairMoney=0
                 }

                this.$axios.post(store.state.server + '/sureReturn?',{
                    'invoiceId':this.$store.state.modal.data.invoiceId,
                    'balanceType':this.$parentInfo.Dialogs_ReturnEquipment.filter.balanceType,
                    'remainBalance':this.$parentInfo.Dialogs_ReturnEquipment.filter.remainBalance,
                    'discountRent':this.$parentInfo.Dialogs_ReturnEquipment.filter.discountRent,
                    'repairMoney':this.$parentInfo.Dialogs_ReturnEquipment.filter.repair_balance,
                    'rent':this.$parentInfo.Dialogs_ReturnEquipment.filter.totalRent,
                }).then((response) => {
                    if (response.data.code == '0000') {
                        this.$message({
                            type: 'success',
                            message: '归还成功!'
                        });
                        this.$Win.closeModal()
                    }
                }).catch((res) => {
                    this.$message({
                        type: 'error',
                        message: res.response.data.content
                    });

                })
            },
            handleClose(done) {
                this.$confirm('确认关闭？')
                    .then(_ => {
                        done();
                    })
                    .catch(_ => {});
            }
        }
    }
</script>

<style lang="scss">
    #msg{
        width:100px !important;
        height:100px !important;
    }
</style>